import { getEdgeUrl } from './getEdgeUrl';

export const NA_CONTENT = [
  {
    title: 'TechCrunch',
    img: getEdgeUrl('images/featured-clients/tech_crunch.png'),
    articleUrl:
      'https://techcrunch.com/2023/03/20/consumer-electronics-reseller-reebelo-series-a/?guccounter=1&guce_referrer=aHR0cHM6Ly93d3cuZ29vZ2xlLmNvbS8&guce_referrer_sig=AQAAAGb49ThSyxTH5iGJ2HmxAbGLCdv0DqscijKyA3LhFr-9s0Zb-SWu-BDysoDUw2uqtmTYSo_ZzoDEOXQZ1YYJ1zqA2t5N8m00P7RImLh_ebLntAw4SP3R9U_9RwzGiChNZEHnLSbXf035Xbh57MCcY4Xi_Rd2Xi6Hp0IXTBXt7ee4',
  },
  {
    title: 'Builtin',
    img: getEdgeUrl('images/featured-clients/built-in.svg'),
    articleUrl:
      'https://builtin.com/how-these-employers-are-future-proofing-their-businesses-2023',
  },
  {
    title: 'RetailWire',
    img: getEdgeUrl('images/featured-clients/retail_wire.png'),
    articleUrl:
      'https://retailwire.com/discussion/refurbished-electronics-platform-reebelo-sets-up-shop-in-the-u-s/',
  },
  {
    title: 'The Business Times',
    img: getEdgeUrl('images/featured-clients/the_business_times.png'),
    articleUrl:
      'https://www.businesstimes.com.sg/startups-tech/startups/electronics-marketplace-reebelo-secures-us20m-fund-global-expansion',
  },
  {
    title: 'Macworld',
    img: getEdgeUrl('images/featured-clients/macworld.svg'),
    articleUrl:
      'https://www.macworld.com/article/670633/where-buy-refurbished-ipad.html',
  },
  {
    title: 'PR Newswire',
    img: getEdgeUrl('images/featured-clients/pr-newswire-logo.png'),
    articleUrl:
      'https://www.prnewswire.com/apac/news-releases/reebelo-encourages-aussies-to-make-the-switch-to-sustainable-tech-this-new-year-302044523.html',
  },
];

export const APAC_CONTENT = [
  {
    title: 'TechCrunch',
    img: getEdgeUrl('images/featured-clients/tech_crunch.png'),
    articleUrl:
      'https://techcrunch.com/2023/03/20/consumer-electronics-reseller-reebelo-series-a/?guccounter=1&guce_referrer=aHR0cHM6Ly93d3cuZ29vZ2xlLmNvbS8&guce_referrer_sig=AQAAAGb49ThSyxTH5iGJ2HmxAbGLCdv0DqscijKyA3LhFr-9s0Zb-SWu-BDysoDUw2uqtmTYSo_ZzoDEOXQZ1YYJ1zqA2t5N8m00P7RImLh_ebLntAw4SP3R9U_9RwzGiChNZEHnLSbXf035Xbh57MCcY4Xi_Rd2Xi6Hp0IXTBXt7ee4',
  },
  {
    title: 'Yahoo! Finance',
    img: getEdgeUrl('images/featured-clients/yahoo.png'),
    articleUrl:
      'https://finance.yahoo.com/news/reebelo-encourages-aussies-switch-sustainable-000300910.html?fr=sycsrp_catchall',
  },
  {
    title: 'e27',
    img: getEdgeUrl('images/featured-clients/e27.png'),
    articleUrl:
      'https://e27.co/roundup-singapores-pre-owned-electronic-goods-marketplace-reebelo-raises-seed-funding-20200616/',
  },
  {
    title: 'The Business Times',
    img: getEdgeUrl('images/featured-clients/the_business_times.png'),
    articleUrl:
      'https://www.businesstimes.com.sg/startups-tech/startups/electronics-marketplace-reebelo-secures-us20m-fund-global-expansion',
  },
  {
    title: 'TEMASEK',
    img: getEdgeUrl('images/featured-clients/temasek.png'),
    articleUrl:
      'https://www.temasek.com.sg/en/news-and-resources/stories/sustainability/hyperx/startups-talk-about-the-hyperspark-pre-accelerator-programme-part-2',
  },
  {
    title: 'ausbiz',
    img: getEdgeUrl('images/featured-clients/ausbiz.png'),
    articleUrl: 'https://www.youtube.com/watch?v=Loudb-aspK0',
  },
];
